import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/components/footer/footer.component';
import { TopnavigationComponent } from './shared/components/topnavigation/topnavigation.component';
import { PosthogService } from './shared/services/posthog.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, TopnavigationComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
  display = true;
  loading = false;
  title = 'verto';
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loading = false;
      }
    });
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      if (isPlatformBrowser(this.platformId)) {
        if(Object.keys(this.queryParams).length !== 0){
          sessionStorage.setItem('external_queryParams', JSON.stringify(this.queryParams));
        }
      }
    });
  }
  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      this.display = false;
    }
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadThirdPartyCss('https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.0/css/flag-icon.min.css');
    }
  }

  loadThirdPartyCss(url: string) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }
}
